// src/App.jsx

import XeokitViewer from "../../components/xeokitViewer";

function XeokitPage() {
  // In real use, you could fetch this URL from your API
//   const modelUrl = "https://xeokit.github.io/xeokit-sdk/assets/models/xkt/schependomlaan/schependomlaan.xkt";

  return (
    <div style={{ width: "100%", height: "100vh" }}>
     <XeokitViewer src="https://xeokit.github.io/xeokit-sdk/assets/models/Duplex.xkt" />
    </div>
  );
}

export default XeokitPage;